/**
 * Channel-specific error types and handling utilities
 */

export class ChannelError extends Error {
  constructor(
    message: string,
    public code: string,
    public details?: unknown
  ) {
    super(message);
    this.name = "ChannelError";
  }
}

export class ValidationError extends ChannelError {
  constructor(message: string, details?: unknown) {
    super(message, 'VALIDATION_ERROR', details);
    this.name = "ValidationError";
  }
}

export class BusinessError extends ChannelError {
  constructor(message: string, details?: unknown) {
    super(message, 'BUSINESS_ERROR', details);
    this.name = "BusinessError";
  }
}

export class ImportError extends ChannelError {
  constructor(message: string, details?: unknown) {
    super(message, 'IMPORT_ERROR', details);
    this.name = "ImportError";
  }
} 